import { lazy } from "react";
import Dashboard from "./fse/dashboard";

const AccettazioneIndex = lazy(() => import("./accettazione/accettazione"));
const MenuAccettazione = lazy(() => import("./accettazione/MenuAccettazione"));
const ContabilitaIndex = lazy(() => import("./contabilita/contabilita"));
const StatisticheIndex = lazy(() => import("./contabilita/Produzione"));
const RiepilogoNre = lazy(() => import("./contabilita/RiepilogoNre"));
const RefertazioneIndex = lazy(() => import("./refertazione/refertazione"));
const ListiniIndex = lazy(() => import("./listino/ListinoIndex"));
const MainIndex = lazy(() => import("./Main/MainIndex"));
const UtentiRegistrati = lazy(() => import("./marketing/utentiRegistrati"));

const dashboardRoutes = [
  {
    path: "/accettazione",
    element: <AccettazioneIndex />
  },
  {
    path: "/accettazione/:isList",
    element: <AccettazioneIndex />
  },
  {
    path: "/accettazione/menu",
    element: <MenuAccettazione />
  },
  {
    path: "/contabilita/riepilogo-nre",
    element: <RiepilogoNre />
  },
  {
    path: "/statistiche",
    element: <StatisticheIndex />
  },
  {
    path: "/contabilita",
    element: <ContabilitaIndex />
  },
  {
    path: "/refertazione",
    element: <RefertazioneIndex />
  },
  {
    path: "/refertazione/:params",
    element: <RefertazioneIndex />
  },
  {
    path: "/main",
    element: <MainIndex />
  },
  {
    path: "/dashboard",
    element: <Dashboard />
  },
  {
    path: "/listino",
    element: <ListiniIndex />
  },
  {
    path: "/marketing",
    element: <UtentiRegistrati />
  },

];

export default dashboardRoutes;
